import { batch } from 'react-redux';
import { normalize } from 'normalizr';

import {
  ACTION_SET_SITE_FOOTER_LINKS_PAGES,
  ACTION_SET_SITE_FOOTER_LINKS_PAGES_CONTENT,
  ACTION_SET_SITE_FOOTER_LINKS_PAGES_SORTED_IDS,
  ACTION_SET_SITE_FOOTER_LINKS_LANGS,
  ACTION_SET_SITE_FOOTER_LINKS_MAX_PAGES,
} from '../actionTypes';

import { SITE_FOOTER_LINK_PAGES_SCHEMA } from '../schemas';


const actionSetSiteStaticPages = (siteFooterLinksPages = {}) => ({
  type: ACTION_SET_SITE_FOOTER_LINKS_PAGES,
  payload: { siteFooterLinksPages },
});

const actionSetSiteStaticPagesContent = (siteFooterLinksPagesContent = {}) => ({
  type: ACTION_SET_SITE_FOOTER_LINKS_PAGES_CONTENT,
  payload: { siteFooterLinksPagesContent },
});

const actionSetSiteStaticPagesSortedIds = siteFooterLinksPagesIds => ({
  type: ACTION_SET_SITE_FOOTER_LINKS_PAGES_SORTED_IDS,
  payload: { siteFooterLinksPagesIds },
});

const actionSetSiteStaticPagesLangs = langs => ({
  type: ACTION_SET_SITE_FOOTER_LINKS_LANGS,
  payload: { langs },
});

const actionSetSiteStaticPagesMaxNumber = maxPages => ({
  type: ACTION_SET_SITE_FOOTER_LINKS_MAX_PAGES,
  payload: { maxPages },
});

export const actionAddSiteStaticPagesData = (dispatch, pages) => {
  const { entities, result } = normalize(pages, SITE_FOOTER_LINK_PAGES_SCHEMA);

  batch(() => {
    dispatch(actionSetSiteStaticPagesSortedIds(result.pages));
    dispatch(actionSetSiteStaticPagesLangs(result.langs));
    dispatch(actionSetSiteStaticPages(entities.siteFooterLinksPages));
    dispatch(actionSetSiteStaticPagesContent(entities.siteFooterLinksPagesContent));
    dispatch(actionSetSiteStaticPagesMaxNumber(result.pagesMaxNumber));
  });
};
